import React from "react";
import "./NSIPsDesc.css";


function NSIPsDesc() {
  return (
    <section className="nsipsdesc">
      <h1>What is a major infrastructure project?</h1>
      <div className="top-text">
          <p>
            The Major Projects Tracker monitors both (1) Nationally Significant Infrastructure Projects (NSIPs) and 
            (2) non-NSIP major projects across the UK.
          </p>
      </div>
      <div className="info-grid">
        
        <div className="info-col">

          <div className="banner banner-thick">
              <span className="banner-number">1</span>
              NSIPs
          </div>

          <p>
            Nationally Significant Infrastructure Projects (NSIPs) are large-scale developments that require a 
            Development Consent Order under the
            {" "}<a href="https://www.legislation.gov.uk/ukpga/2008/29/contents" target="_blank" rel="noopener noreferrer">
              Planning Act 2008
            </a>. 
            They follow a specialised planning process overseen by the Planning Inspectorate rather than local authorities. 
            </p>
        </div>
        <div className="info-col">


          <div className="banner banner-thick">  
              <span className="banner-number">2</span>
                Non-NSIP Major Projects
          </div>

          <p>
            Major projects represent significant developments
            that are not classed as NSIPs and are announced by 
            the relevant Secretary of State. These projects typically 
            follow standard planning processes but merit tracking due to their scale and importance.
          </p>
        </div>
      </div>



      

    </section>
  );
}

export default NSIPsDesc;
